// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"b44faf10","478":"1860ddf3"}[chunkId] + ".chunk.js";
};